export function Step3({ className }: { className?: string }) {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="96" height="96" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27 14C27 11.2386 29.2386 9 32 9H40H42H54H56H64C66.7614 9 69 11.2386 69 14V30H67V14C67 12.3431 65.6569 11 64 11H56V13C56 14.1046 55.1046 15 54 15H42C40.8954 15 40 14.1046 40 13V11H32C30.3431 11 29 12.3431 29 14V74.8621V82C29 83.6569 30.3431 85 32 85H64C65.6569 85 67 83.6569 67 82V74.8621V57.5H69V74.8621V82C69 84.7614 66.7614 87 64 87H32C29.2386 87 27 84.7614 27 82V74.8621V14ZM42 11V13H54V11H42ZM41 82C41 81.4477 41.4477 81 42 81H53C53.5523 81 54 81.4477 54 82C54 82.5523 53.5523 83 53 83H42C41.4477 83 41 82.5523 41 82Z"
        fill="black"
      />
      <path
        d="M68 35C66.5946 34.9996 65.2087 35.3285 63.9533 35.9602C62.6978 36.5919 61.6079 37.509 60.7707 38.6378C59.9335 39.7666 59.3724 41.0758 59.1323 42.4606C58.8922 43.8453 58.9798 45.267 59.3881 46.6118L49 57V63H55L65.3881 52.6118C66.626 52.9877 67.9304 53.0922 69.2124 52.9183C70.4944 52.7445 71.7239 52.2962 72.817 51.6042C73.9101 50.9122 74.8411 49.9926 75.5467 48.9082C76.2522 47.8238 76.7157 46.6 76.9055 45.3203C77.0953 44.0406 77.0069 42.7349 76.6465 41.4924C76.286 40.2499 75.6619 39.0997 74.8167 38.1203C73.9715 37.1408 72.9251 36.355 71.7487 35.8166C70.5724 35.2781 69.2937 34.9996 68 35ZM68 51C67.3114 50.9996 66.6267 50.8978 65.9678 50.6978L64.821 50.35L60.7927 54.3784L59.4141 53L58 54.4141L59.3787 55.7927L57.7928 57.3787L56.4141 56L55 57.4141L56.3787 58.7927L54.1716 61H51V57.8284L61.6495 47.1787L61.3022 46.032C60.8748 44.623 60.9025 43.1151 61.3816 41.7227C61.8606 40.3304 62.7664 39.1246 63.9703 38.2768C65.1741 37.429 66.6147 36.9824 68.087 37.0005C69.5593 37.0187 70.9884 37.5006 72.171 38.3778C73.3536 39.255 74.2295 40.4827 74.6741 41.8864C75.1187 43.2901 75.1093 44.7983 74.6473 46.1963C74.1853 47.5944 73.2942 48.8112 72.1008 49.6736C70.9074 50.536 69.4724 51.0002 68 51Z"
        fill="#656BBB"
      />
      <path
        d="M69 45C70.1046 45 71 44.1046 71 43C71 41.8954 70.1046 41 69 41C67.8954 41 67 41.8954 67 43C67 44.1046 67.8954 45 69 45Z"
        fill="#656BBB"
      />
    </svg>
  );
}
